import { render } from "./PartnersNew.vue?vue&type=template&id=c047d00a&ts=true"
import script from "./PartnersNew.vue?vue&type=script&lang=ts"
export * from "./PartnersNew.vue?vue&type=script&lang=ts"

import "./PartnersNew.vue?vue&type=style&index=0&id=c047d00a&lang=scss"

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__